import React, { useEffect, useState, useContext } from 'react';
import { ProductModalContext } from '../../ProductModalContext';

import { Button } from 'web-store-modules/packages/web-store-ui-library'

import { BuyNowOnce, BuyNowClicked, AddToWishlistClicked, ProductContactUsCLicked } from '../../../../../../utils/Analytics';
// import ProductModalDropdown from './dropdown-button/ProductModalDropdown.jsx';
// import ProductModalCartOverlay from './ProductModalCartOverlay';
import { AddToCartContext } from '../../../../add-to-cart/AddToCartContext';
import SizeSelector from './size-selector/SizeSelector';

const arrowUrl = `https://cdn.obsessvr.com/details-arrow.png`;
const ProductModalButtons = ({ sku, title, price, downsizedThumbnail, buttonFontStyle,
    addToCartFontStyle, buyNowFontStyle, productButtonCopy,
    addToCartCopy, url, cartUrl, setShowingAddToCartPrompt,
    addToCartEnabled, sizeDropdownEnabled, groupProducts }) => {

    const { colors, buttonBorderRadius, buttonBorderWidth, buyNowBorderActiveOn, addToCartBorderActiveOn, productInfo, variantSize, setVariantSize, variantColor, productVariantMap } = useContext(ProductModalContext)
    const { addToCart, removeFromCart, cartList } = useContext(AddToCartContext);
    const [isInWishlist, setIsInWishlist] = useState(false);
    const [firstSeenInWishlistButton, setFirstSeenInWishlistButton] = useState(false);
    console.log({ addToCartFontStyle });
    useEffect(() => {
        if (cartList.find(item => item.TITLE === title)) {
            setIsInWishlist(true);
        } else {
            setIsInWishlist(false);
        }
    }, [cartList])


    const buyButtonClicked = () => {
        BuyNowClicked(sku, title);
        window.open(url, '_blank');
    }

    const contactUrlClicked = () => {
        ProductContactUsCLicked(sku, title);
        window.open(`https://bookings-us.qudini.com/SBWA7HXKYMH/venues/1387/products`, '_blank');
    }

    const addToCartClicked = (option) => {
        // addToCart is only active when the item isn't in the cart/wishlist
        if (isInWishlist && firstSeenInWishlistButton) {
            return;
        }

        // addToCart is only active when variantSize and variantColor are set
        if (sizeDropdownEnabled && !variantSize && !variantColor) {
            return;
        }

        const variantSKU = productVariantMap.features_map[variantColor][variantSize];
        const productSKU = variantSKU ? variantSKU : sku;

        const variantName = productVariantMap.siblings[variantSKU];
        const productName = variantName ? variantName : title;

        if (isInWishlist) {
            removeFromCart(productName)
        } else {
            addToCart({
                TITLE: productName,
                PRICE: price,
                DOWNSIZED_THUMBNAIL: downsizedThumbnail,
            });

            AddToWishlistClicked(productSKU, productName);
            setFirstSeenInWishlistButton(true);
        }
    }

    const renderCartText = () => {
        if (isInWishlist && firstSeenInWishlistButton) {
            return 'This item has been added to Cart';
        }
        if (isInWishlist) {
            return 'Remove from Cart';
        }
        return addToCartCopy;
    }

    const addToCartColors = () => {
        if (isInWishlist) {
            return colors && colors.addToCartSecondaryColor;
        } else if (variantSize) {
            return colors && colors.addToCartPrimaryColor;
        }
        return colors && colors.addToCartPrimaryColor;
    }

    return (
        <div className='product-button-container' style={{ width: addToCartEnabled && url ? '100%' : '50%', minWidth: '80%' }}>
            {sizeDropdownEnabled &&
                <SizeSelector
                    sku={sku}
                    groupProducts={groupProducts}
                    variantSize={variantSize}
                    setVariantSize={setVariantSize}
                    colors={colors}
                    variantColor={variantColor}
                    productVariantMap={productVariantMap}
                />
            }
            {addToCartEnabled && <Button
                hoverStyleChange={true}
                onClick={contactUrlClicked}
                primaryColor={addToCartColors()}
                secondaryColor={colors && colors.addToCartSecondaryColor}
                className="product-button product-contact-btn flex-center obsessvr-regularFont full-width pointer"
                style={{ padding: '0', margin: '0 1%' }}
                primaryBorderWidth={addToCartBorderActiveOn && addToCartBorderActiveOn.primary ? buttonBorderWidth : undefined}
                secondaryBorderWidth={addToCartBorderActiveOn && addToCartBorderActiveOn.secondary ? buttonBorderWidth : undefined}
                primaryBorderColor={colors && colors.addToCartBorderColor}
                secondaryBorderColor={colors && colors.addToCartBorderColor}
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont' style={{ fontFamily: addToCartFontStyle.fontFamily, fontSize: '11px' }}>
                    {renderCartText()}
                    <img
                        src={arrowUrl}
                        className='product-contact-arrow'
                    />
                </p>
            </Button>}
            {!sizeDropdownEnabled && url && <Button
                hoverStyleChange={true}
                onClick={buyButtonClicked}
                primaryColor={colors && colors.buyNowPrimaryColor}
                secondaryColor={colors && colors.buyNowSecondaryColor}
                className="product-button product-learn-btn flex-center obsessvr-regularFont full-width pointer"
                style={{ padding: '0', margin: '0 1%' }}
                primaryBorderWidth={buyNowBorderActiveOn && buyNowBorderActiveOn.primary ? buttonBorderWidth : undefined}
                secondaryBorderWidth={buyNowBorderActiveOn && buyNowBorderActiveOn.secondary ? buttonBorderWidth : undefined}
                primaryBorderColor={colors && colors.buyNowBorderColor}
                secondaryBorderColor={colors && colors.buyNowBorderColor}
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont' style={{ fontFamily: 'Prelo Bold', fontSize: '11px' }} >
                    {productButtonCopy}
                    <img
                        src={arrowUrl}
                        className='product-learn-arrow'
                    />
                </p>
            </Button>}
        </div>
    )
}

export default ProductModalButtons;